import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Domain, Workspace } from "../../../path";
import usePost from "../../../Hooks/usePost";

const Header = () => {
  const Navigation = useNavigate();
  const { school_id, class_id } = useParams();
  const [SchoolListData, setSchoolListData] = useState([]);
  const Schoollist = usePost(`${Workspace[Domain].API_Path}/class_list`);

  const Go_Back = () => {
    Navigation(`/schooldetail/${school_id}`);
  };
  useEffect(() => {
    return () => {
      setSchoolListData([]);
    };
  }, []);

  useEffect(() => {
    if (Schoollist?.Post != null) {
      switch (Schoollist?.Post?.status) {
        case 200:
          setSchoolListData(() => [...Schoollist?.Post?.body?.class_list]);
          break;
        case 401:
          break;
        case 403:
          break;
        default:
          break;
      }
    } else {
      Schoollist.Postcall({
        school_id: atob(school_id),
      });
    }
  }, [Schoollist?.Post]);

  return (
    <div className="w-full flex flex-wrap items-start px-2 border-b-2 pb-4 max-[700px]:pb-0">
      <button className="text-3xl mx-3" onClick={Go_Back}>
        <i className="fa-solid fa-arrow-left-long"></i>
      </button>
      <div className="max-[700px]:w-10/12">
        <h3 className="font-semibold text-lg">Teachers evaluation</h3>
        <p className="font-medium text-[#0009] my-1">
          Process of identifying the students with learning difficulties
        </p>
      </div>

      <div className="ml-auto bg-[#2da3dc] px-4 my-2 py-2 rounded">
        <select
          name=""
          id=""
          className="bg-[#2da3dc] text-[white] font-semibold outline-none border-none cursor-pointer"
          value={atob(class_id)}
          onChange={(e) => {
            Navigation(`/classdetail/${school_id}/${btoa(e.target?.value)}`);
          }}
        >
          {SchoolListData?.map((item, index) => {
            return (
              <option
                key={index}
                value={item?.class_id}
                className="bg-[white] text-[#2da3dc]"
              >
                {item?.class_standard}
              </option>
            );
          })}
          <option value="other" className="bg-[white] text-[#2da3dc]">
            Other
          </option>
        </select>
      </div>
    </div>
  );
};

export default Header;
